import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { TableauDashboard } from '../features/home/home.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  private isLoggedIn = new BehaviorSubject<boolean>(false);
  private alertMessage = new Subject<string>();
  private permissionsLoaded = new BehaviorSubject<boolean>(false);
  constructor() {}
  setLoggedIn(value: boolean) {
    this.isLoggedIn.next(value);
  }
  getLoggedIn(): Observable<boolean> {
    return this.isLoggedIn.asObservable();
  }
  setAlertMessage(message: string) {
    this.alertMessage.next(message);
  }
  getAlertMessage(): Observable<string> {
    return this.alertMessage.asObservable();
  }

  setPermissions(isLoaded: boolean) {
    this.permissionsLoaded.next(isLoaded);
  }

  getPermissions(): Observable<boolean> {
    return this.permissionsLoaded.asObservable();
  }
}
